<template>
  <a-config-provider :locale="locale" :getPopupContainer="setRenderDom">
    <router-view />
  </a-config-provider>
</template>

<script>
  import { onBeforeMount } from 'vue'
  import { useStore } from 'vuex'
  import { useRouter } from 'vue-router'
  import zhCN from 'ant-design-vue/es/locale/zh_CN'

  import useFetchETagFunc from './utils/updateCompare'
  import { getLanguageList } from '@/http/api'

  export default {
    components: {},
    setup() {
      const store = useStore()
      const { initETag } = useFetchETagFunc()

      const setRenderDom = (node) => {
        if (node) {
          // return node.parentNode
          return document.body
        }
        let shadowDom = document.getElementById(
          `__qiankun_microapp_wrapper_for_iol_lab__`
        )?.shadowRoot
        let targetNode = document.body
        if (shadowDom) {
          targetNode = shadowDom.querySelectorAll(`#app`)[0]
        }
        return targetNode
      }

      // 浏览器html/etag与服务器html/etag进行对比
      initETag()

      // 获取语种列表
      const getLanguageFunc = () => {
        if (!localStorage.getItem('languageList')) {
          getLanguageList().then((res) => {
            const data = res.data || []
            localStorage.setItem('languageList', JSON.stringify(data))
          })
        }
      }

      onBeforeMount(() => {
        getLanguageFunc()

        store
          .dispatch('comm/getSettingDetail', { showDefaultIfNotFound: true })
          .then((res) => {
            const icoUrl = res.settings.ico_url.value || ''
            document
              .querySelector('link[rel="icon"]')
              .setAttribute('href', icoUrl)
          })
      })

      return {
        locale: zhCN,
        setRenderDom,
      }
    },
  }
</script>

<style lang="scss">
  #app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #000;
    height: 100%;
  }
</style>
